export default __webpack_public_path__ + "static/media/porfile-image.b43dbc20.png";